(function () {
  'use strict';

  if (!window.location.pathname.includes('/search')) return;

  const urlParams = new URLSearchParams(window.location.search);
  const query = (urlParams.get('q') || '').trim().toUpperCase();

  if (!query || !/^[A-Z0-9\-]+$/.test(query)) return;

  function skuMatches(sku) {
    const s = (sku || '').toUpperCase();
    return (
      s === query ||
      s.startsWith(query + '-') ||
      s.startsWith(query + ' ')
    );
  }

  function getProductData(handle) {
    return fetch('/products/' + handle + '.js')
      .then(function (r) { return r.json(); })
      .then(function (p) {
        // Fix: images array contains full URL strings directly
        var imageUrl = null;
        if (p.images && p.images.length > 0) {
          imageUrl = p.images[0];
          // Sometimes it's an object with src
          if (typeof imageUrl === 'object' && imageUrl.src) {
            imageUrl = imageUrl.src;
          }
        }
        // Fallback: get from featured_image
        if (!imageUrl && p.featured_image) {
          imageUrl = p.featured_image;
        }

        return {
          handle: handle,
          title: p.title,
          url: '/products/' + handle,
          price: p.variants
            .filter(function (v) { return skuMatches(v.sku); })
            .reduce(function (min, v) {
              return v.price < min ? v.price : min;
            }, Infinity),
          image: imageUrl,
          skus: p.variants.map(function (v) {
            return (v.sku || '').toUpperCase();
          })
        };
      })
      .catch(function () { return null; });
  }

  // suggest.json max limit is 10 — so we use /search.json instead
  // which supports pagination and returns up to 250 results
  function fetchAllHandles(query) {
    var allHandles = [];
    var page = 1;
    var perPage = 50;

    function fetchPage() {
      return fetch(
        '/search/suggest.json?q=' +
          encodeURIComponent(query) +
          '&resources[type]=product' +
          '&resources[limit]=10' +
          '&resources[options][fields]=variants.sku'
      )
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var products =
          (data.resources &&
            data.resources.results &&
            data.resources.results.products) || [];
        products.forEach(function (p) {
          var m = p.url.match(/\/products\/([^?#]+)/);
          if (m) allHandles.push(m[1]);
        });
      });
    }

    // suggest.json only gives 10 — use collections/all + search workaround
    // Better: use /products.json with pagination to find all matching handles
    function fetchProductPages(pg) {
      return fetch(
        '/products.json?limit=' + perPage + '&page=' + pg
      )
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (!data.products || !data.products.length) return;

          data.products.forEach(function (p) {
            var hasMatch = p.variants && p.variants.some(function (v) {
              return skuMatches(v.sku);
            });
            if (hasMatch && allHandles.indexOf(p.handle) === -1) {
              allHandles.push(p.handle);
            }
          });

          // If full page returned, fetch next page
          if (data.products.length === perPage) {
            return fetchProductPages(pg + 1);
          }
        });
    }

    return fetchProductPages(1).then(function () {
      return allHandles;
    });
  }

  function injectResults(grid, products) {
    grid.innerHTML = '';

    document.querySelectorAll(
      '.pagination, nav[role="navigation"], .pagination-wrapper'
    ).forEach(function (el) { el.style.display = 'none'; });

    if (!products.length) {
      var wrap = grid.closest('.template-search__results');
      if (wrap) {
        wrap.innerHTML =
          '<p class="text-center" style="padding:3rem 1rem;">' +
          'No results found for &ldquo;' + query.toLowerCase() + '&rdquo;.' +
          '</p>';
      }
      updateCount(0);
      return;
    }

    products.forEach(function (p) {
      var priceStr = p.price !== Infinity
        ? '$' + (p.price / 100).toFixed(2)
        : '';

      // Clean image URL — remove query params for cleaner src
      var imgSrc = p.image ? p.image.split('?')[0] : null;

      var imgHtml = imgSrc
        ? '<div class="media media--transparent media--adapt media--hover-effect">' +
          '<img src="' + imgSrc + '" alt="' + p.title.replace(/"/g, '&quot;') + '" ' +
          'class="motion-reduce" loading="lazy" ' +
          'style="width:100%;height:100%;object-fit:contain;">' +
          '</div>'
        : '<div class="media media--transparent media--adapt"></div>';

      grid.insertAdjacentHTML('beforeend',
        '<li class="grid__item js-pagination__item">' +
          '<div class="card-wrapper underline-links-hover">' +
            '<div class="card card--standard card--media">' +
              '<div class="card__inner color-scheme-2 gradient ratio" style="--ratio-percent: 100%;">' +
                '<div class="card__media">' +
                  imgHtml +
                '</div>' +
              '</div>' +
              '<div class="card__content">' +
                '<div class="card__information">' +
                  '<div class="card__vendor caption-with-letter-spacing light">MACE</div>' +
                  '<h3 class="card__heading h5">' +
                    '<a href="' + p.url + '" class="full-unstyled-link">' +
                      p.title +
                    '</a>' +
                  '</h3>' +
                  '<div class="card-information">' +
                    '<div class="price">' +
                      '<div class="price__container">' +
                        '<span class="price-item price-item--regular">' +
                          priceStr +
                        '</span>' +
                      '</div>' +
                    '</div>' +
                  '</div>' +
                '</div>' +
              '</div>' +
            '</div>' +
          '</div>' +
        '</li>'
      );
    });

    updateCount(products.length);
  }

  function updateCount(count) {
    var el = document.querySelector('.js-product-count');
    if (el) {
      el.textContent = count + ' result' + (count !== 1 ? 's' : '');
    }
    document.querySelectorAll('[role="status"]').forEach(function (el) {
      if (/\d/.test(el.textContent)) {
        el.textContent =
          'Showing ' + count + ' result' + (count !== 1 ? 's' : '');
      }
    });
  }

  function showLoader() {
    if (document.getElementById('sku-loader')) return;
    var s = document.createElement('style');
    s.textContent = '@keyframes skubar{0%{width:0}100%{width:100%}}';
    document.head.appendChild(s);
    var d = document.createElement('div');
    d.id = 'sku-loader';
    d.style.cssText =
      'position:fixed;top:0;left:0;height:3px;width:0;background:#e63946;' +
      'z-index:9999;animation:skubar 1.2s ease-in-out infinite;';
    document.body.appendChild(d);
  }

  function hideLoader() {
    var d = document.getElementById('sku-loader');
    if (d) d.remove();
  }

  async function init() {
    var grid = document.querySelector('ul.product-grid');
    var tries = 0;
    while (!grid && tries < 20) {
      await new Promise(function (r) { setTimeout(r, 200); });
      grid = document.querySelector('ul.product-grid');
      tries++;
    }
    if (!grid) return;

    showLoader();

    try {
      var handles = await fetchAllHandles(query);

      if (!handles.length) {
        injectResults(grid, []);
        hideLoader();
        return;
      }

      var products = await Promise.all(handles.map(getProductData));

      var matched = products.filter(function (p) {
        return p && p.skus.some(skuMatches);
      });

      injectResults(grid, matched);
    } catch (e) {
      console.error('SKU search error:', e);
    }

    hideLoader();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();